import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { RefreshCw, Star } from 'lucide-react';
import { useAcademyRatingFeedback } from '../hooks/useAcademyAdmin';

export function AcademyRatingFeedbackPanel() {
  const { data: rows = [], isLoading, isFetching, error, refetch } = useAcademyRatingFeedback();

  return (
    <div className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h2 className="text-base font-semibold text-foreground">Valoraciones de artículos</h2>
          <p className="text-sm text-muted-foreground">
            Motivos de no me gusta y comentarios de mejora de artículos de Academia.
          </p>
        </div>
        <button
          type="button"
          onClick={() => void refetch()}
          disabled={isLoading || isFetching}
          className="inline-flex items-center gap-2 rounded-lg border border-border bg-card px-3 py-2 text-sm font-medium hover:bg-muted/60 disabled:opacity-50"
        >
          <RefreshCw className={`h-4 w-4 ${isFetching ? 'animate-spin' : ''}`} />
          Actualizar
        </button>
      </div>

      {error ? (
        <div className="rounded-lg border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive">
          {error.message}
        </div>
      ) : null}

      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/50 text-left text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              <tr>
                <th className="px-4 py-3">Fecha</th>
                <th className="px-4 py-3">Artículo</th>
                <th className="px-4 py-3">Creador</th>
                <th className="px-4 py-3">Usuario</th>
                <th className="px-4 py-3">Voto</th>
                <th className="px-4 py-3">Comentario</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={6} className="px-4 py-8 text-center text-muted-foreground">
                    Cargando…
                  </td>
                </tr>
              ) : rows.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-4 py-8 text-center text-muted-foreground">
                    No hay valoraciones con comentario todavía.
                  </td>
                </tr>
              ) : (
                rows.map((r) => (
                  <tr key={r.id} className="border-t border-border hover:bg-muted/30 align-top">
                    <td className="px-4 py-3 whitespace-nowrap text-muted-foreground">
                      {r.created_at
                        ? format(new Date(r.created_at), "d MMM yyyy HH:mm", { locale: es })
                        : '—'}
                    </td>
                    <td className="px-4 py-3 max-w-[14rem]">
                      <p className="font-medium text-foreground line-clamp-2">{r.content_title || '—'}</p>
                    </td>
                    <td className="px-4 py-3 text-muted-foreground whitespace-nowrap">
                      {r.creator_name || '—'}
                    </td>
                    <td className="px-4 py-3 font-medium whitespace-nowrap">{r.username || '—'}</td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {r.reaction_type === 'dislike' ? (
                        <span className="text-muted-foreground">No me gusta</span>
                      ) : (
                        <span className="inline-flex items-center gap-1 text-amber-500">
                          <Star className="h-3.5 w-3.5 fill-amber-500" />
                          {r.rating}/5
                        </span>
                      )}
                    </td>
                    <td className="px-4 py-3 max-w-lg break-words text-foreground/90">
                      {r.comment || '—'}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
